import _ from 'underscore';

import ActionList from '../../actionList';
import Module from '../../core/module';
import ScheduleFormModule from '../schedule/form';
import ScheduleTemplatesModule from '../schedule/templates.list';
import Task from '../../model/task';

import { promisify, } from '../../utils/promisify';
import { delay, rejectOn } from '../../utils/promisify';
import { error } from '../../ui/messages'
import { handle } from '../../service/messages';  
import { get, del, } from '../../http/api';
import { ask, } from '../../utils/popups';
import { beginLock, endLock } from '../../loader';
import { save as saveTask } from '../../model/task.utils';

// todo: module stop!

const BACK = 'back--from-task';

export default Module.extend( {

    initialize(options = {}) {
        Module.prototype.initialize.call( this, options );

        const actionDefs = {
            
            ok: {
                handler: () =>
                    save( this ).then( () => close( this ) ),
        
                disabled: () =>
                    this.options.isRoot || 
                    !this.TaskForm || 
                    !this.TaskForm.hasDiff( { fields: this.options.fields } ),
            },
    
            apply: {
                handler: () =>
                    save( this ),
        
                disabled: () =>
                    !this.TaskForm || !this.TaskForm.hasDiff( { fields: this.options.fields } ),
            },
        
            rollback: {
                handler: () => {
                    this.TaskForm.rollback();
                    this.bind( this.model );
                },
        
                disabled: () =>
                    !this.TaskForm || !this.TaskForm.hasDiff( { fields: this.options.fields } ),
            },

            close: {
                handler: () =>
                    close( this ),

                disabled: () =>
                    this.options.isRoot,
            },
        };
        
        this.options.actions = new ActionList( actionDefs );
    },

    template: 'jst/module.tasks.form',

    url() {
        return `task/${this.model.id}`;
    },

    open(taskModel) {
        const fetchingTask = taskModel instanceof Task
            ? Promise.resolve( taskModel )
            : Task.byId( taskModel )

        return fetchingTask.then( taskModel => {
            const objId = taskModel.get( 'service_object_id' );
            const layerId = taskModel.get( 'service_object_layer_id' );
            if (objId)
                this.object = {
                    attrs: [],
                    loaded: false,
                    failed: false,
                },
    
                get( `/layers/${layerId}/feature/${objId}` ).mapsurfer()
                    .map( response => response.feature )
                    .chain( () => get( `/layers/${layerId}` ).mapsurfer() )
                    .map( response => response.layer.layer
                        .fields.sort( (f1, f2) => f1.order - f2.order ) )
                    .filter( field => field.view )
                    .map( ({ name, rusName }, index, fields, response, obj) => 
                        ({ name: rusName, value: obj[name] }) )
                    .execute()
                    .then( attrs => this.object.attrs.push( ...attrs ) )
                    .then( () => this.object.loaded = true, () => this.object.failed = true )
                    .then( () => this.Card.render() );
    
            return this.bind( taskModel );
        } );
    },

    start() {
        this.listenTo( this.TaskForm.Assignee, 'points', 
            points => this.Map.setLocations( points ) );
        this.listenTo( this.TaskForm.Assignee, 'assignee:dropdown-hide', 
            // clear filtered locations after 250ms delay
            // but don't clear if user clicks on map in these 250ms
            points => Promise.race( [rejectOn( 'assignee:click', this.Map ), delay( 250 )] )
                .then( () => this.Map.clearLocations() ) );
        this.listenTo( this.Map, 'assignee:assign',
            ({ user }) => this.TaskForm.model.assign( user ) );

        const [org] = this.options.organizations.toJSON()
            .filter( org => org.id == this.model.get( 'organization_id' ) );
        if (org)
            this.TaskForm.focus();
        else
            // task of deleted org/cluster
            this.TaskForm.disable(),
            this.Schedule && this.Schedule.disable(),
            this.Map.disable(),
            this.Comments.disable();

        return this;
    },

    stop() {
        this.stopListening( this.TaskForm.Assignee );
        this.stopListening( this.Map );
        
        this.options.actions.clearDependencies( this.model );

        return this;
    },

    onBind(model, previousModel) {
        if (previousModel)
            this.options.actions.clearDependencies( previousModel );
        this.options.actions.depend( model, 'change' );
    },

    serialize() {
        const { contracts, organizations, 
            types, statuses, priorities, fields,
            serviceObjectMappings } = this.options;
        const { locationService, } = this.options;

        const context = this.model.toJSON();

        context.contracts = contracts.toJSON();
        context.organizations = organizations.toJSON();
        context.types = types.toJSON();
        context.statuses = statuses.toJSON();
        context.priorities = priorities.toJSON();
        context.fields = fields.toJSON();
        context.serviceObjectMappings = serviceObjectMappings;

        context.locationService = locationService;

        context.date = this.model.get( 'date' );
        context.capabilities = this.model.capabilities_;
        context.actionList = this.options.actions;

        context.object = this.object;

        return context;
    },

    afterRender(context, firstTime) {
        this.stopListening( this.Map, 'map:click' );
        if (context.capabilities.edit || context.capabilities.update_point)
            this.listenTo( this.Map, 'map:click',
                location => this.model.set( 'location', location ) );
    },

    [Module.event( ':schedule:edit' )]({ id }) {
        return this.trigger( ScheduleFormModule.POPUP_EDIT, 
            // pass id only to force Schedule.byId in Form
            id );
    },

    [Module.event( ':schedule:delete' )]({ id }) {
        ask( 'schedule::modal delete schedule - confirmation text', 
            'schedule::modal delete schedule - title', 
            'actions::yes', 
            'actions::no',
            () => del( `/timetables/${id}` )
                .blocking( this ).cerebellum()
                .execute() )
            .then( () => {
                this.model.get( 'schedule' ).deleted = true;
                return this.Schedule.render();
            } );
    },

    [Module.event( ':schedule:templates' )]({ id }) {
        return this.trigger( ScheduleTemplatesModule.POPUP, 
            // pass id only to force Schedule.byId in Template List
            id );
    },

}, {

    BACK,

} );

function create(form) {
    return promisify( new Task( form.model.toJSON() ).save() )
        .then( resp => resp.newsId )
        .then( id => form.model.set( 'id', id ) )
}

function save(layout) {
    const form = layout.TaskForm;
    const { result, messages } = form.validate();
    if (!result)
        return Promise.reject( handle( form, error( messages[0] /* [text, field] */ ) ) );

    const op = !form.model.id ? create( form ) : saveTask( layout );

    return beginLock( this ), op
        .then( response => new Task( response, { parse: true } ) )
        // .then( model => form.model.set( model.toJSON() ) )
        // make form "remember" changes
        // .then( () => form.commit() )
        // force toolbar to update itself (firing event on its actionList)
        // .then( () => actions.trigger( 'update' ) )
        // .then( postpone )
        // .then( () => form.focus() )
        // todo don't use render here
        .then( updatedModel => layout.bind( updatedModel ) )
        // need to call update here because there is pending
        // onBindDone() for TaskForm when onBind called
        .finally( () => endLock( this ) )
        .finally( () => layout.options.actions.trigger( 'update' ) )
        .catch( message => handle( form, error( message ) ) );
        ;
}

function close(layout) {
    layout.trigger( BACK );
}






// WEBPACK FOOTER //
// ./src/js/module/tasks/form.js